import React from 'react';
import { Button } from '../../components/ui/Button';

interface ConfirmationModalProps {
  order: any;
  onClose: () => void;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ order, onClose }) => {
  return (
    <div className="flex flex-col w-full p-6 text-center">
      <div className="mb-4 text-green-500 flex justify-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-16 w-16"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>
      <h2 className="text-2xl font-bold text-gray-800 mb-2">Order Updated Successfully!</h2>
      <p className="text-gray-600 mb-6">
        Order <span className="font-semibold">{order.order_number || order.order_id}</span> has been successfully updated with the new details.
      </p>
      
      <div className="bg-gray-50 border rounded-md p-4 text-left mb-6 text-sm grid grid-cols-2 gap-4">
        <div>
          <span className="font-semibold text-gray-700 block mb-1">Shipping To:</span>
          <p>{order.destination_address?.contact_name}</p>
          <p>{order.destination_address?.address1}</p>
          <p>{order.destination_address?.city}, {order.destination_address?.state} {order.destination_address?.pincode}</p>
          <p>{order.destination_address?.contact_no}</p>
        </div>
        <div>
          <span className="font-semibold text-gray-700 block mb-1">Package Specs:</span>
          <p>Weight: {order.dead_weight} kg</p>
          <p>Dimensions: {order.length} x {order.breadth} x {order.height} cm</p>
        </div>
      </div>
      
      <Button onClick={onClose} className="w-full">
        Done
      </Button>
    </div>
  );
};
